import ArrowRotateLeft from './src/arrow-rotate-left-combined';
export default ArrowRotateLeft;